export default __webpack_public_path__ + "images/fechamento-de-caixa-ico.svg";